<template>
	<c-dialog ref="dialog" title="配置不良品项" width="900" @resolve="submitHandle">
		<div class="flex">
			<dl class="flex-grow">
				<dt class="flex-between-center">
					<p>已选项</p>
					<span>拖动可进行排序</span>
				</dt>
				<dd>
					<c-drag-sort v-model="currentList" class="list flex-wrap">
						<template #default="{item, id, index}">
							<c-drag-item :key="id" class="list-option flex-center-cross z-crt">
								<p class="ellipsis flex-grow">{{item.defects_name}}</p>
								<a @click="deleteHandle(index)"><i class="c-icon-cross"></i></a>
							</c-drag-item>
						</template>
					</c-drag-sort>
				</dd>
			</dl>
			<div class="line"></div>
			<dl class="flex-grow">
				<dt class="flex-between-center">
					<p>待选项</p>
					<span>点击添加到已选列表</span>
				</dt>
				<dd>
					<ul class="list flex-wrap">
						<li v-for="(item, i) in defectsList" :key="i" v-if="!currentList.find(temp => temp.defects_id == item.defects_id)" class="list-option flex-center-cross" @click="currentList.push(item)">
							<p class="ellipsis">{{item.defects_name}}</p>
						</li>
					</ul>
				</dd>
			</dl>
		</div>
	</c-dialog>
</template>

<script>
	export default {
		name: 'defectsConfig',
		props: {
		},
		data() {
			return {
				defectsList: [],
				currentList: []
			}
		},

		methods: {
			open() {
				this.$refs.dialog.open();
				this.request({
					url: '/user/config/defects',
					data: {},
					success: data => {
						this.defectsList = data.enableDefectsList.concat(data.selectedDefectsList);
						this.currentList = data.selectedDefectsList;
					}
				});
			},

			deleteHandle(index) {
				this.currentList.splice(index, 1);
			},

			submitHandle(stop, next) {
				stop();
				var defects_ids = this.currentList.map(item => item.defects_id).join(',');
				if (!defects_ids || defects_ids.length == 0){
					this.$message({
						message: '请至少配置指一项不良品项',
						type: 'warn'
					});
					return;
				}
				this.request({
					url: '/user/config/defects/edit',
					data: {
						defects_ids: defects_ids
					},
					loading: true,
					success: () => {
						this.$message({
							message: '保存成功'
						});
						next();
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	dl {
		height: 600px;

		dt {
			height: 36px;
			padding: 0 12px 0 16px;
			background: #FAFAFA;

			p {
				font-size: 14px;
			}

			span {
				font-size: 12px;
				color: #666;
			}
		}

		dd {
			padding: 12px 14px;

			.list {
				gap: 10px;

				&-option {
					box-sizing: border-box;
					width: calc(33.3333% - 7px);
					height: 35px;
					padding: 0 8px 0 12px;
					font-size: 13px;
					color: #333;
					background: #F5F5F5;
					cursor: pointer;

					&:not(.z-crt):hover {
						color: #fff;
						background: #00B38A;
					}

					&.z-crt {
						color: #00B38A;
						background: #EEF9F7;

						a {
							padding: 4px;
							color: #C7D9D3;

							&:hover {
								color: #FF414A;
							}
						}
					}
				}
			}
		}
	}
	.line {
		width: 6px;
		border: 1px solid #ddd;
		border-width: 0 1px;
		background: #F9F9F9;
	}
</style>